/* TK: collection Filter & Sort (sections/template--collection.liquid, assets/tk-facets.css)
   The theme's filtering script owns the drawer: it opens from its own button ([data-drawer-open-btn], now hidden)
   and closes from [data-drawer-close-btn], with its focus trap, inert handling and live filtering.
   Here: the "Filter" / "Sort" links press that button, the "View results" footer presses close, the drawer title
   and footer are moved into the drawer, focus goes back to the link that opened it, and filter URLs are kept clean. */
if (!window.__tkFacets) {
  window.__tkFacets = true;

  let lastOpener = null;

  const mount = () => {
    const form = document.getElementById('CollectionFiltersForm');
    if (!form) return;
    const head = form.querySelector('.drawer__close');
    const title = document.querySelector('[data-tk-facets-title]');
    if (head && title && !head.contains(title)) {
      head.classList.add('tk-facets-head');
      head.prepend(title);
      title.hidden = false;
    }
    const foot = document.querySelector('[data-tk-facets-foot]');
    if (foot && foot.parentElement !== form) {
      form.appendChild(foot);
      foot.hidden = false;
    }

    // Clean URLs: the two sort menus are named sort_by_desktop / sort_by_mobile, so every filter change put both
    // in the address (?sort_by_desktop=manual&sort_by_mobile=manual...). Shopify ignores them, so they only made
    // messy, duplicate URLs. The theme already copies the chosen sort into the hidden "sort_by" field, which is
    // the one Shopify reads, so the menus don't need names.
    // TK: the search page names them sort_bydesktop / sort_bymobile (no underscore), so match any sort_by* select
    // except the real "sort_by" (that one is a hidden input anyway).
    form.querySelectorAll('select[name^="sort_by"]:not([name="sort_by"])').forEach((select) => select.removeAttribute('name'));
    // Keep an active sort (?sort_by=...) when a filter is changed after a page load.
    const sortInput = form.querySelector('#sort_by_input');
    const activeSort = new URLSearchParams(window.location.search).get('sort_by');
    if (sortInput && activeSort && !sortInput.value) sortInput.value = activeSort;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-tk-facets-open]');
    if (opener) {
      event.preventDefault();
      mount();
      const open = document.querySelector('[data-drawer-open-btn]');
      if (!open) return;
      lastOpener = opener;
      open.click();
      if (opener.dataset.tkFacetsOpen === 'sort') {
        const select = document.getElementById('SortBymobile');
        if (select) setTimeout(() => select.focus(), 380); // after the slide-in
      }
      return;
    }

    if (event.target.closest('[data-tk-facets-close]')) {
      event.preventDefault();
      const close = document.querySelector('[data-drawer-close-btn]');
      if (close) close.click();
    }
  });

  // The theme refocuses its own (hidden) button on close; send focus back to the link instead.
  new MutationObserver(() => {
    if (lastOpener && !document.body.classList.contains('js-drawer-open-filter')) {
      const el = lastOpener;
      lastOpener = null;
      el.focus();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
}

/* TK: products per row on the collection grid.
   Desktop (990px+): 3 / 4 / 5 / All (8, images only), stored on .collection_grid as data-tk-cols.
   Phones and tablets: 1 / 2 / All (4, images only), stored as data-tk-cols-m. CSS in assets/tk-facets.css.
   Both choices are remembered in this browser. Card images say how wide they show (sizes) so the browser picks a sharp
   enough file; that's rebuilt to match, including for cards added later by "Load more" or a filter change. */
if (!window.__tkView) {
  window.__tkView = true;

  const KIND = {
    d: { key: 'tk_grid_cols', attr: 'data-tk-cols', valid: /^(3|4|5|8)$/ },
    m: { key: 'tk_grid_cols_m', attr: 'data-tk-cols-m', valid: /^(1|2|4)$/ },
  };
  // The card image sizes written by snippets/grid-view-item.liquid
  const CARD_SIZES = /^\(min-width: 990px\) calc\(\(100vw - 32px\) \/ \d+\), \(min-width: 750px\) calc\(\(100vw - 32px\) \/ \d+\), calc\(\(100vw - 16px\) \/ \d+\)$/;

  const sizeImages = (grid) => {
    const list = grid.querySelector('.collection-main-body-inner');
    if (!list) return;
    const d = grid.getAttribute(KIND.d.attr) || 4;
    const m = grid.getAttribute(KIND.m.attr) || 2;
    const sizes = `(min-width: 990px) calc((100vw - 32px) / ${d}), (min-width: 750px) calc((100vw - 32px) / ${m}), calc((100vw - 16px) / ${m})`;
    list.querySelectorAll('img[sizes]').forEach((img) => {
      const s = img.getAttribute('sizes');
      if (s !== sizes && CARD_SIZES.test(s)) img.setAttribute('sizes', sizes);
    });
  };

  const apply = (kind, value, save) => {
    const k = KIND[kind];
    const grid = document.querySelector('.collection_grid');
    if (!grid || !k.valid.test(String(value))) return;
    grid.setAttribute(k.attr, value);
    grid.querySelectorAll(`.tk-view__btn[${k.attr}]`).forEach((b) => b.setAttribute('aria-pressed', b.getAttribute(k.attr) === String(value) ? 'true' : 'false'));
    sizeImages(grid);
    if (save) { try { localStorage.setItem(k.key, String(value)); } catch (e) {} }
  };

  const init = () => {
    const grid = document.querySelector('.collection_grid');
    if (!grid) return;
    Object.keys(KIND).forEach((kind) => {
      const k = KIND[kind];
      let value = grid.getAttribute(k.attr);
      try { const saved = localStorage.getItem(k.key); if (k.valid.test(saved || '')) value = saved; } catch (e) {}
      apply(kind, value, false);
    });
    // Cards added later (Load more, filters) get the same image sizes
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sizeImages(grid); });
    }).observe(grid, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.tk-view__btn');
    if (!btn) return;
    if (btn.hasAttribute(KIND.m.attr)) apply('m', btn.getAttribute(KIND.m.attr), true);
    else apply('d', btn.getAttribute(KIND.d.attr), true);
  });
}
